/**
 * Canonical Refine `resource` id (aligned with backend `REFINE_RESOURCE_NAMES` and
 * `src/resources/index.tsx` `name`) → i18n key under `common.json` → `resources.*`
 * (same leaf rule as the admin sidebar / `i18nProvider` menu mapping).
 */
export function refineResourceLeaf(canonicalResourceName: string): string {
  return canonicalResourceName.includes('.')
    ? canonicalResourceName.slice(canonicalResourceName.lastIndexOf('.') + 1)
    : canonicalResourceName;
}

export function refineResourcesI18nKey(canonicalResourceName: string): string {
  return `resources.${refineResourceLeaf(canonicalResourceName)}`;
}
